import { color } from "helpers/styled"
import { useT } from "react-polyglot-hooks"
import styled from "styled-components"
import Item from "../Item"

const OnlineScoringCard = styled(Item)`
  --promo-bg: ${color("skyBlue")};
`

function OnlineScoring() {
  const t = useT()

  return (
    <OnlineScoringCard
      title={t("car_data.online.title")}
      description={t("car_data.online.description")}
      image="chrono-1"
      alt="Online Scoring"
    />
  )
}

export default OnlineScoring
